<template lang="pug">
  transition(
  name="modal"
  )
    .modal-mask(
    @click="onClickMask($event)"
    )
      .modal-wrapper
        .modal.modal_sleeping-house-editor(
        @click="onClickWrapper($event)"
        )
          .modal__close
            button.modal-button-close(
            @click="onCloseModal()"
            )
              img(src="@/assets/images/icons/modal-button-close.svg")
          .modal__body
            .house-editor
              .house-editor__title
                h2.title Спальный корпус
              .house-editor__form
                .form
                  .form__elem
                    .form-elem(
                      :class="{'form-elem_error':fieldsErrors.name.value}"
                    )
                      .form-elem__title Название
                      .form-elem__body
                        simple-select-form(
                        :list-data="sleepingHousesNames"
                        :default-value="fields.name"
                        @onChangeDefaultValue="changeSleepingHouseName"
                        :type="'name'"
                        )
                  .form__elem
                    .form-elem
                      .form-elem__title Вместимость
                      .form-elem__body
                        input.input.input_full(
                        maxlength="128"
                        disabled="true"
                        v-model="fields.capacity"
                        )
                  .form__elem(
                    v-for="(item, index) in fields.extra"
                  )
                    .form-elem
                      .form-elem__title(
                        v-if="index === 0"
                      ) Дополнительная информация
                      .form-elem__body
                        input.input.input_full(
                        maxlength="128"
                        v-model="fields.extra[index]"
                        )
                  .form__elem.form__elem_button
                    .form-elem.form-elem_right
                      .form-elem__body
                        button.button.button_paint-main--light.button_narrow(
                        @click.prevent="onAddSleepingHouse"
                        )
                          .button__text Добавить пункт
                  .form__elem.form__elem_button
                    .form-elem
                      .form-elem__body
                        button.button.button_paint-main.button_long(
                        @click.prevent="onSaveSleepingHouse"
                        )
                          .button__text Сохранить
                      .form-elem__error(
                        v-if="currentErrorMessage.length > 0"
                      ) {{currentErrorMessage}}

</template>

<script>
import SimpleSelectForm from "../simpleSelectForm/SimpleSelectForm";
export default {
  name: "SleepingHouseEditorModal",
  components: {SimpleSelectForm},
  props: {
    currentSleepingHouse: {
      type: Object,
      default: null
    },
    currentSleepingHouseIndex: {
      type: Number,
      default: null
    },
    sleepingHousesNames: {
      type: Array,
      default: () => ([])
    },
    campData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fields: {
        name: {
          value: null,
          text: "Корпус не выбран"
        },
        capacity: "",
        extra: [
          ""
        ]
      },
      fieldsErrors: {
        name: {
          value: false,
          message: "Выберите корпус"
        }
      },
      currentErrorMessage: ""
    };
  },
  computed: {
    mode() {
      if (this.currentSleepingHouse) {
        return "edit";
      }
      return "create";
    }
  },
  methods: {
    onClickMask() {
      this.onCloseModal();
    },
    onClickWrapper(e) {
      e.stopPropagation();
    },
    onCloseModal() {
      this.$emit("close");
    },
    changeSleepingHouseName(data, type) {
      this.fields.name = data;
      this.fields.capacity = this.setCapacity(data.value);
      this.resetErrors(type);
      // this.setCampHousesData();
      // this.setDisabledHousesInTable();
    },
    setCapacity(val) {
      if (val) {
        const a = this.campData.houses.find(item => item.id === val);
        return a.capacity;
      }
      return "";
    },
    onAddSleepingHouse() {
      this.fields.extra.push("");
    },
    setFields(house) {
      this.fields.name = house.name;
      this.fields.capacity = house.capacity;
      this.fields.extra = house.extra.split(";");
    },
    validation() {
      if (!this.fields.name.value) {
        this.fieldsErrors.name.value = true;
        this.currentErrorMessage = this.fieldsErrors.name.message;
        return false;
      }
      return true;
    },
    resetErrors(field) {
      this.fieldsErrors[field].value = false;
      this.currentErrorMessage = "";
    },
    onSaveSleepingHouse() {
      if (!this.validation()) {
        return;
      }
      let extra = this.fields.extra.filter(item => {
        return item.length > 0;
      });
      extra = extra.join(";");
      const data = {
        name: this.fields.name,
        capacity: this.fields.capacity,
        extra: extra,
        type: "корпус"
      };
      if (this.mode === "create") {
        this.$emit("add-sleeping-house", data);
      }
      if (this.mode === "edit") {
        this.$emit("update-sleeping-house", data, this.currentSleepingHouseIndex);
      }
      this.$emit("close");
    }
  },
  mounted() {
    if (this.mode === "edit") {
      this.setFields(this.currentSleepingHouse);
    }
  }
};
</script>
